import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/article/article-render";
import { useArticleUtils } from "~/lib/hooks/article-utils";
import type { hooksPostiesArticleArticle$key } from "~/queries/__generated__/hooksPostiesArticleArticle.graphql";

import { GenericPostiesArticle } from "./generic-posties-article";

export const usePostiesArticle = (
  provider: DefaultComponentsProvider,
  article_: hooksPostiesArticleArticle$key,
) => {
  const article = useFragment(
    graphql`
      fragment hooksPostiesArticleArticle on Article
      @argumentDefinitions(customContents: { type: "[CustomContentInput]", defaultValue: [] }) {
        ...articleUtilsArticle
        ...genericPostiesArticleContent @arguments(customContents: $customContents)
      }
    `,
    article_,
  );

  const { getArticleType } = useArticleUtils();

  const handleRenderPostiesArticle = () => {
    switch (getArticleType(article)) {
      default:
        return <GenericPostiesArticle provider={provider} reference={article} />;
    }
  };

  return {
    handleRenderPostiesArticle,
  };
};
